import { render, staticRenderFns } from "./headFirstWidget.vue?vue&type=template&id=9c5282ec&scoped=true"
import script from "./headFirstWidget.vue?vue&type=script&lang=js"
export * from "./headFirstWidget.vue?vue&type=script&lang=js"
import style0 from "./headFirstWidget.vue?vue&type=style&index=0&id=9c5282ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5282ec",
  null
  
)

export default component.exports